import React, { Component } from 'reactn'
import { Button } from 'react-bootstrap'

export default class TableDetail extends Component {
  constructor (props) {
    super(props)
    this.state = {
      row: {}
    }
  }

  componentDidMount () {
    const { row } = this.props
    this.setState({ row })
  }

  render () {
    const { container, save } = styles
    const { row } = this.state

    return (
      <div style={container}>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button style={save} variant='danger' onClick={(el) => this.props.delete(row)}>Elimina</Button>
          <Button style={save} variant='success' onClick={() => this.props.open(row)}>Visualizza</Button>
        </div>
      </div>
    )
  }
}

const styles = {
  container: {
    width: '100%'
  },
  save: {
    width: 150,
    height: 40,
    margin: 8
  }
}
